'use client';

import { CursorFollower } from '@/components/global/partials/CursorFollower';
import * as React from 'react';
import { RefObject } from 'react';

type PlayReelFollowerProps = {
  containerRef: RefObject<HTMLElement>;
  label?: string;
  open?: boolean;
};

export function PlayVideoCursorFollower({
  containerRef,
  label = 'Play Video',
  open,
}: PlayReelFollowerProps) {
  return (
    <CursorFollower
      containerRef={containerRef}
      className="pointer-events-none absolute z-[100] flex items-center justify-center mix-blend-difference"
      options={{
        spring: { stiffness: 220, damping: 24, mass: 0.6 },
        offset: { x: -50, y: -70 },
      }}
      motionProps={{
        initial: { scale: 0.6, opacity: 0 },
        animate: { scale: 1, opacity: 1 },
        exit: { scale: 0.6, opacity: 0 },
        transition: { duration: 0.22, ease: 'easeOut' },
      }}
    >
      <div className="pointer-events-none text-white flex items-center gap-[1.5rem] min-w-[15rem]">
        {open ? (
          <svg
            className="w-[2rem] h-[2rem] mix-blend-difference"
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            fill="none"
            viewBox="0 0 17 17"
          >
            <g stroke="#fff" style={{ mixBlendMode: 'difference' }}>
              <path d="m.5.5 16 16M.5 16.5l16-16"></path>
            </g>
          </svg>
        ) : (
          <svg className="w-[4.16288rem] h-[3.56313rem] mix-blend-difference" xmlns="http://www.w3.org/2000/svg" width="34" height="29" viewBox="0 0 34 29" fill="none">
            <path d="M33.3035 8.85124L33.0983 8.63301C32.0149 8.92185 30.0532 9.31338 27.6364 9.24278L27.4505 9.42892C27.9185 10.5458 28.5339 12.9014 26.2709 14.4097C24.3093 15.9181 22.0271 15.7705 20.309 14.0182C17.8024 11.4572 16.7062 7.30436 18.1358 5.78957C18.732 5.13488 19.4692 4.78827 20.0398 4.60855V4.35181C18.3409 2.70223 17.3216 1.01414 16.8088 0H16.4947C15.9754 1.01414 14.9561 2.70865 13.2637 4.35181V4.60855C13.8342 4.78827 14.5715 5.13488 15.1677 5.78957C16.5972 7.30436 15.501 11.4572 12.9944 14.0182C11.2828 15.7705 9.00059 15.9245 7.03251 14.4097C4.77595 12.9014 5.38496 10.5458 5.85294 9.42892L5.66703 9.24278C3.25021 9.31338 1.28855 8.92185 0.205141 8.63301L0 8.85124C0.371819 9.90389 0.878261 11.7974 0.794922 14.1658L0.980832 14.352C3.04507 13.524 4.53876 14.3327 5.78884 15.1671C11.4495 18.9413 14.9561 23.3123 16.4883 28.505H16.8024C18.3345 23.3123 21.8412 18.9413 27.5018 15.1671C28.7519 14.3327 30.252 13.524 32.3098 14.352L32.4957 14.1658C32.4124 11.8038 32.9188 9.90389 33.2906 8.85124H33.3035ZM16.6613 24.243C15.2189 21.4124 13.5842 19.551 11.1225 17.0606C14.2381 16.3097 15.9626 13.4149 16.6613 11.2775C17.3601 13.4149 19.0846 16.3097 22.2002 17.0606C19.7385 19.551 18.1037 21.4189 16.6613 24.243Z" fill="#F2F0EF"/>
          </svg>
        )}

        <span className="text-[2.5rem] font-newsreader leading-none whitespace-nowrap mix-blend-difference mt-[.5rem]">
          {label}
        </span>
      </div>
    </CursorFollower>
  );
}
